export const getItemResponse_v2_schema = {
  type: 'object',
  properties: {
    key: {
      type: 'string',
    },
    value: {},
  },
  required: ['key', 'value'],
};
